import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Single, clean scroll-to-top on every route change.
 * Uses useLayoutEffect to run synchronously after DOM mutations
 * but before browser paint. No refs, no requestAnimationFrame,
 * no setTimeout. Just one scroll call at the right time.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
